import { Image } from 'react-native';

import LogoImage from '../../../assets/images/grove_logo.png';
import { LinkableComponent } from './GroveButtons';

export const GroveLogo = ({ isLarge = false }: { isLarge?: boolean }) => {
    return (
        <LinkableComponent href="/">
            <Image
                source={LogoImage}
                style={{
                    resizeMode: 'contain',
                    ...(isLarge
                        ? { width: 200, height: 80 }
                        : { width: 100, height: 40 }),
                }}
            />
        </LinkableComponent>
    );
};
